import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface PageTitleState {
  childTitle: string | null;
  childTitlePiiUserId: string | null;
}

const initialState: PageTitleState = { childTitle: null, childTitlePiiUserId: null };

export const pageTitleSlice = createSlice({
  name: 'pageTitle',
  initialState,
  reducers: {
    setChildPageTitle: (
      state: PageTitleState,
      action: PayloadAction<{ title: string | null; piiUserId?: string | null }>,
    ) => {
      state.childTitle = action.payload.title;
      state.childTitlePiiUserId = action.payload.piiUserId ?? null;
    },
  },
});

export const selectChildPageTitle = (state: RootState) => state.pageTitle?.childTitle ?? null;

export const selectChildPageTitlePiiUserId = (state: RootState) => state.pageTitle?.childTitlePiiUserId ?? null;

export const { setChildPageTitle } = pageTitleSlice.actions;

export default pageTitleSlice.reducer;
